/**
 * Canal éditeur du Carrousel : la sidebar demande au canvas d'aller à une
 * slide (l'œil d'aperçu d'un item de la liste). La slide courante est un état
 * interne d'Embla, pas une prop persistée — même approche que le canal
 * d'aperçu des Volets (utils/accordionPanelsRegistry.js).
 *
 * Registre module par instance de rendu : l'iframe de l'éditeur et le viewer
 * ont chacun leur bundle, donc leur propre Set.
 */

const listeners = new Set();

/**
 * @param {(blockId: string, slideIndex: number) => void} listener
 * @returns {() => void} désabonnement
 */
export function subscribeSlidePreview(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function notifySlidePreview(blockId, slideIndex) {
  listeners.forEach((listener) => listener(blockId, slideIndex));
}
